import { useQuery } from "@atlassiansox/microscopekit";
import { WarGameTemplateForServiceQuery, CreateExerciseTemplateMappingMutation } from "../../../graphql";
import { useMutationUI } from "../../../hooks";
export var useImportWargamePlan = function (serviceId, onCompleted) {
    var _a;
    var _b = useQuery(WarGameTemplateForServiceQuery, { variables: { serviceId: serviceId } }), data = _b.data, loading = _b.loading;
    var _c = useMutationUI({
        mutation: CreateExerciseTemplateMappingMutation,
        options: {
            refetchQueries: ["wargameExerciseMasterData"],
            awaitRefetchQueries: true,
            onCompleted: onCompleted
        },
        successMessage: "Wargame plan imported successfully"
    }), mutate = _c.mutate, isLoading = _c.isLoading;
    var importWargamePlan = function (templateId, exerciseId) {
        return mutate({
            variables: { exerciseID: exerciseId, templateID: templateId.toString() }
        });
    };
    return {
        wargameTemplates: (_a = data === null || data === void 0 ? void 0 : data.warGameTemplateForService) !== null && _a !== void 0 ? _a : [],
        isWargameTemplatesLoading: loading,
        importWargamePlan: importWargamePlan,
        isImportingWargamePlan: isLoading
    };
};
